export default function getDataViaPostV2(
  url: string,
  onSuccess: (response: any) => void,
  body: any,
  onError?: (err: any) => void
) {
  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  })
    .then(response => {
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.json();
    })
    .then(json => onSuccess(json))
    .catch(err => {
      console.error("Fetch failed:", err);
      if (onError) onError(err);
    });
}